var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 121,
    viewBox: "0 0 289 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1002 50.3723H60.6475L103.226 13.5747H212.716L200.767 25.4735L176.067 50.3723H117.8H74.1002Z",
    fill: "url(#paint0_linear_5290_65727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.562 35.1688V11.18H217.227V18.7445L212.715 13.5747L176.219 50.3723L176.219 85.9738L176.219 120.9H246.169V51.9054L231.562 35.1688Z",
    fill: "url(#paint1_linear_5290_65727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.219 50.3721H60.6475V120.9H176.219V50.3721Z",
    fill: "url(#paint2_linear_5290_65727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.252 72.6039H135.921V94.069H160.252V72.6039Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.037 71.8371H104.747V120.9H126.037V71.8371Z",
    fill: "#91959C",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4156 79.5031V71.8374H71.292V79.5031H79.6547H80.4156Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6547 85.6357H71.292V93.3025H80.4156V85.6357H79.6547Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6231 71.8371H86.499V79.5032H95.6231V71.8371Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6231 85.6362H86.499V93.3023H95.6231V85.6362Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.914 80.2702V72.6034H199.789V80.2702H208.153H208.914Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M208.153 86.4027H199.789V94.0684H208.914V86.4027H208.153Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.12 72.6039H214.996V80.27H224.12V72.6039Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.12 86.4027H214.996V94.0688H224.12V86.4027Z",
    fill: "#91959C",
    fillOpacity: 0.27
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2666 121C49.76 121 58.2666 119.86 58.2666 118.453C58.2666 117.046 49.76 115.905 39.2666 115.905C28.7732 115.905 20.2666 117.046 20.2666 118.453C20.2666 119.86 28.7732 121 39.2666 121Z",
    fill: "url(#paint3_linear_5290_65727)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4665 82.1852C54.4665 90.9961 38.6331 115.905 38.6331 115.905C38.6331 115.905 22.7998 90.9961 22.7998 82.1852C22.7998 77.954 24.468 73.8961 27.4373 70.9043C30.4066 67.9124 34.4339 66.2316 38.6331 66.2316C42.8324 66.2316 46.8597 67.9124 49.829 70.9043C52.7983 73.8961 54.4665 77.954 54.4665 82.1852Z",
    fill: "url(#paint4_linear_5290_65727)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2671 91.7052C44.164 91.7052 48.1337 87.7135 48.1337 82.7894C48.1337 77.8654 44.164 73.8737 39.2671 73.8737C34.3701 73.8737 30.4004 77.8654 30.4004 82.7894C30.4004 87.7135 34.3701 91.7052 39.2671 91.7052Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5290_65727",
    x1: 136.682,
    y1: 13.5747,
    x2: 136.682,
    y2: 76.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFD6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5290_65727",
    x1: 204.351,
    y1: 11.18,
    x2: 204.351,
    y2: 120.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFD6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5290_65727",
    x1: 118.433,
    y1: 50.3721,
    x2: 118.433,
    y2: 120.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFD6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5290_65727",
    x1: 39.2666,
    y1: 115.905,
    x2: 39.2666,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5290_65727",
    x1: 38.6331,
    y1: 66.2316,
    x2: 38.6331,
    y2: 115.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContent);
export default __webpack_public_path__ + "94e336eadbdd554ef72708dc21ea70c5.svg";
export { ForwardRef as ReactComponent };